import {
    Create,
    Datagrid,
    DeleteButton,
    Edit,
    List,
    NumberField,
    NumberInput,
    required,
    Show,
    ShowButton,
    SimpleForm,
    SimpleShowLayout,
    TextField,
    TextInput
} from 'react-admin'
import DateTimeField from "../Components/Fields/DateTimeField";
import ListActions from "../Components/Toolbars/TopToolbars/ListActions";
import ShowActions from "../Components/Toolbars/TopToolbars/ShowActions";
import EditActions from "../Components/Toolbars/TopToolbars/EditActions";
import CreateActions from "../Components/Toolbars/TopToolbars/CreateActions";
import CreateToolbar from "../Components/Toolbars/BottomToolbars/CreateToolbar";
import Aside from "../Components/Aside";
import CompanyField from "../Components/Fields/CompanyField";
import CompanyInput from "../Components/Inputs/CompanyInput";

const Title = ({record}) => {
    return <span>{record ? `#${record.uid}: ${record.name}` : ''}</span>;
};

export const TaxGroupList = (props) => (
    <List
        title="ra.page.taxGroups"
        sort={{ field: 'updatedAt', order: 'DESC' }}
        aside={<Aside filters={{
            id: 'live',
            name: 'live',
            percentage: 'live',
            createdAt: 'dateRange'
        }}/>} {...props} actions={<ListActions/>} >
        <Datagrid rowClick="edit">

            <NumberField label="#" source="originId" sortBy={'id'}/>

            <TextField label="ra.field.name" source={'name'}/>

            <TextField label="ra.field.percentage" source={'percentage'}/>

            <CompanyField label="ra.field.company"/>

            <DateTimeField label="ra.field.createdAt" source={'createdAt'}/>
            <DateTimeField label="ra.field.updatedAt" source={'updatedAt'}/>

            <ShowButton/>
            <DeleteButton/>

        </Datagrid>
    </List>
);

export const TaxGroupShow = (props) => (
    <Show actions={<ShowActions/>} title={<Title/>} {...props}>
        <SimpleShowLayout>

            <TextField label="ra.field.name" source={'name'}/>

            <TextField label="ra.field.percentage" source={'percentage'}/>

            <TextField label="ra.field.company"/>
            <CompanyField/>

            <DateTimeField label="ra.field.createdAt" source={'createdAt'}/>
            <DateTimeField label="ra.field.updatedAt" source={'updatedAt'}/>

        </SimpleShowLayout>
    </Show>
);

export const TaxGroupEdit = (props) => (
    <Edit actions={<EditActions/>} title={<Title/>} {...props}>
        <SimpleForm>

            <TextInput label="ra.field.name" source="name"/>

            <NumberInput label="ra.field.percentage" source="percentage"/>

            <CompanyInput label="ra.field.company"/>

        </SimpleForm>
    </Edit>
)

export const TaxGroupCreate = (props) => (
    <Create actions={<CreateActions/>} {...props}>
        <SimpleForm toolbar={<CreateToolbar/>}>

            <TextInput label="ra.field.name" source="name" validate={required()}/>

            <NumberInput label="ra.field.percentage" source="percentage" validate={required()}/>

            <CompanyInput label="ra.field.company"/>

        </SimpleForm>
    </Create>
);
